import React from "react";
import ReactDOM from "react-dom/client";
import { useEffect, useState } from "react";

const images = window.LOSTDREAM_IMAGES || [];


const LostDream = () => {


    return (
        <><img src={images[0]}
            class='mx-auto md:w-3/4'
            alt='Lost a dream'>
        </img>
            <p class={`text-4xl md:text-3xl mx-auto md:mx-px font-Unbounded text-primary font-semibold pad-b-25 pad-t-100 md:pad-t-50 md:pad-r-50 lh-1_2 text-center`}>
                Lost a dream?
            </p>
            <p class='md:pad-1 text-primary mt-4 text-sm font-worksans pad-b-25 mx-auto md:mx-px text-center'>
                Every Flexbag includes an integrated name tag for you to fill out with your kids name. If you loose a Flexbag contact us and we do everything to helping that your child's dreams are returned to its owner.
            </p></>
    );
};

// ✅ Render React Component in Liquid File
const rootEl = document.getElementById("react-lostdream");
if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<LostDream />);
}
